import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TransferState } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { IChangePasswordForm, IProfileForm } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private _baseApi: string = `${environment.apiUrl}/account/me`;

  constructor(
    private _http: HttpClient,
    private _transferState: TransferState,
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) {}

  getProfile(): Observable<any> {
    return this._http.get(`${this._baseApi}/`);
  }

  updateProfile(profile: IProfileForm): Observable<any> {
    return this._http.put(`${this._baseApi}/`, profile);
  }

  changePassword(changePasswordForm: IChangePasswordForm): Observable<any> {
    return this._http.put(`${this._baseApi}/change_password/`, changePasswordForm);
  }
}
